const observer = new MutationObserver(function (mutations) {
  // Trenne den Observer vorübergehend, um Endlosschleifen zu vermeiden
  observer.disconnect();

  const reviewLabels = document.querySelectorAll(
    ".kl_reviews__star_rating_widget__label"
  );

  // Iterate over each label found
  reviewLabels.forEach((reviewLabel) => {
    if (reviewLabel) {
      // Extract the number and remove ' Bewertungen'
      const number = reviewLabel.textContent.match(/\d+/); // Match the number
      if (number) {
        // Set the text content to the number in parentheses
        reviewLabel.textContent = `(${number[0]})`;
      }
    }
  });

  // Beobachtung wieder aktivieren
  observer.observe(document.body, { childList: true, subtree: true });
});

// Start observing the document body for changes
observer.observe(document.body, { childList: true, subtree: true });